<template>
    <div>
        <Toolbar>
            <template>
                <BackButton :to="__('general.brands')" :href="$route('brands.index')"/>
            </template>
            <template v-slot:right>
                <ToolbarLink
                    :href="$route('brands.edit', {brandUuid: brand.uuid})">
                    <i class="fas fa-pen mr-1"/>
                    {{ __('general.edit') }}
                </ToolbarLink>
                <ToolbarLink
                    :href="$route('brands.edit.distribution', {brandUuid: brand.uuid})">
                    <i class="fas fa-lock-open mr-1"/>
                    {{ __('general.product.distribution') }}
                </ToolbarLink>
            </template>
        </Toolbar>
        <Card>
            <div class="card-body">
                <FormGroupNew :label=" __('brand.distribution.product')">
                    <select-product-data-distribution-type v-model="form.type" :brand-uuid="brand.uuid"/>
                </FormGroupNew>
                <FormGroupNew label="" v-if="form.type === 'limited'" >
                    <selected-stores-table v-model="stores" :file="form.file" @file="(f) => form.file = f"/>
                </FormGroupNew>
            </div>
            <div class="card-footer d-flex justify-content-between">
                <a :href="$route('brands.index')" class="btn btn-default btn-hover-warning ml-1">
                    <i class="fas fa-times mr-1"/>{{ __('actions.abort') }}
                </a>
                <button class="btn btn-primary" @click="submit">
                    <i v-if="!loading" class="fas fa-save mr-1"/>
                    <ButtonSpinner v-else show />
                    {{ __('general.save') }}
                </button>
            </div>
        </Card>
    </div>

</template>

<script>
import SelectProductDataDistributionType from '@components/MegaOptions/SelectProductDataDistributionType.vue'
import CsrfToken from '@components/CsrfToken.vue'
import SelectedStoresTable from '@components/Store/SelectedStoresTable.vue'
import ButtonSpinner from "@components/ButtonSpinner.vue";
import Card from '@components/Cards/Card.vue'
import Toolbar from '@components/Toolbar.vue'
import BackButton from '@components/BackButton.vue'
import ToolbarLink from '@components/ToolbarLink.vue'
import FormGroupNew from '@components/Form/FormGroupNew.vue'

export default {
    components: {
        FormGroupNew,
        ToolbarLink,
        BackButton, Toolbar,
        Card,
        ButtonSpinner,
        SelectedStoresTable,
        SelectProductDataDistributionType,
        CsrfToken
    },

    props: {
        brand: Object,
        storesInit: Array,
    },

    data() {
        return {
            form: this.$inertia.form({
                type: 'all',
                file: null,
                store_uuid: [],
            }),
            stores: [],
            loading: false,
        }
    },

    mounted() {
        this.form.type = this.brand.distribution
        this.stores = this.storesInit
    },

    methods: {
        submit() {
            this.loading = true

            for (let store of this.stores) {
                this.form.store_uuid.push(store.id);
            }

            this.form.post(this.$route('brands.distribution', [this.brand.uuid]), {
                preserveScroll: true,
                preserveState: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onSuccess: () => {
                    toastr.success(__('general.settings_saved'))
                    this.loading = false
                    this.file = null;
                },
                onError: () => {
                    toastr.error(__('general.error_check_data'))
                    this.loading = false
                },
            })
        },
    },
}
</script>
